import {
  campaignMetricsConstants,
  toastTypes,
} from "../../constants";
import { customToast } from "../../../../shared";
import { campaignMetricsService } from "../../services";
import { withSpinner, success } from "../../../../redux/actions/utilities";

const { CAMPAIGN_METRICS_SPINNER, GET_CAMPAIGN_METRICS } =
  campaignMetricsConstants;

//Getting campaign metrics data
const getCampaignMetricsData = (body) => {
  return (dispatch) => {
    withSpinner(dispatch, CAMPAIGN_METRICS_SPINNER, () =>
      campaignMetricsService
        .getCampaignMetricsData(body)
        .then(
          (response) => {
            dispatch(success(response, GET_CAMPAIGN_METRICS));
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
          }
        )
    );
  };
};

export const campaignMetricsActions = {
  getCampaignMetricsData,
};
